import { Link } from "react-router-dom";
import Magnetic from "@/components/Magnetic";

/* Pill CTA. variant: leaf | ink | outline | ghostDark */
export default function CTA({ to, href, onClick, children, variant = "leaf", className = "", type, dataTestId }) {
  const base =
    "group inline-flex items-center justify-center gap-2 rounded-full px-7 py-3.5 text-sm font-700 tracking-tight transition-[background-color,color,transform,border-color] duration-300 active:scale-[0.97]";
  const variants = {
    leaf: "bg-leaf text-ink hover:bg-ink hover:text-white",
    ink: "bg-ink text-white hover:bg-leaf hover:text-ink",
    outline: "border border-ink/25 text-ink hover:border-ink hover:bg-ink hover:text-white",
    ghostDark: "border border-white/20 text-white hover:border-leaf hover:bg-leaf hover:text-ink",
    leafDark: "bg-leaf text-obsidian hover:bg-white hover:text-obsidian",
  };
  const cls = `${base} ${variants[variant]} ${className}`;
  const arrow = (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" className="transition-transform duration-300 group-hover:translate-x-1">
      <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );

  const inner = (
    <>
      {children}
      {arrow}
    </>
  );

  let el;
  if (to) el = <Link to={to} className={cls} data-testid={dataTestId}>{inner}</Link>;
  else if (href) el = <a href={href} className={cls} data-testid={dataTestId} target="_blank" rel="noreferrer">{inner}</a>;
  else el = <button type={type || "button"} onClick={onClick} className={cls} data-testid={dataTestId}>{inner}</button>;

  return <Magnetic className="inline-block" strength={0.25}>{el}</Magnetic>;
}
